const MATCH_SOUNDCLOUD_URL = /^https?:\/\/(www\.)?(on\.)?soundcloud\.com\/(.)+(\/(.)+)?/;

export const isSoundcloudUrl = (url: string) => MATCH_SOUNDCLOUD_URL.test(url);
